import { render, staticRenderFns } from "./MyTicketsInterface.vue?vue&type=template&id=13d0d526&scoped=true"
import script from "./MyTicketsInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyTicketsInterface.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyTicketsInterface.vue?vue&type=style&index=0&id=13d0d526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d0d526",
  null
  
)

export default component.exports